import {
  Card,
  Typography,
  Stack,
  Skeleton,
} from '@mui/material';
import React from 'react';

export default function CompobotCardSkeleton() {
  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: 3,
        boxShadow: 1,
        paddingBottom: 0,
      }}
    >
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Skeleton variant="circular" width={48} height={48} />
          <div>
            <Skeleton width={120} height={24} />
            <Skeleton width={80} height={16} />
          </div>
        </Stack>

        <Stack spacing={1} mt={1}>
          <Skeleton width="80%" height={20} />
          <Skeleton width="70%" height={20} />
          <Skeleton width="65%" height={20} />
        </Stack>

        <Stack direction="row" spacing={1} mt={2} justifyContent="center">
          <Skeleton variant="rectangular" width={40} height={36} />
          <Skeleton variant="rectangular" width={40} height={36} />
          <Skeleton variant="rectangular" width={40} height={36} />
          <Skeleton variant="rectangular" width={40} height={36} />
        </Stack>
      </Stack>
    </Card>
  );
}
